export default {
  home: "Home",
  user: {
    list: "Người dùng",
    groups: "Nhóm quyền",
  },
  about: {
    abouts: "Thông tin",
    editAbout: "Chỉnh sửa thông tin",
    reviewEditAbout: "Xem trước",
  },
  instruction: {
    instruction: "Hướng dẫn",
    instruction_detail: "Chi tiết hướng dẫn",
    edit_instruction: "Chỉnh sửa hướng dẫn",
    review_instruction: "Kiểm tra lại",
    add_instruction: "Thêm hướng dẫn",
  },
  customer: {
    list: "Khách hàng",
    locations: "Chi nhánh",
    locationDetail: "Chi tiết chi nhánh",
    editLocation: "Chỉnh sửa chi nhánh",
    units: "Các đơn vị",
    devices: "Thiết bị",
    licenses: "Giấy phép",
    detail: "Chi tiết khách hàng",
    edit: "Chỉnh sửa khách hàng",
    addCustomer: "Khách hàng mới",
  },
  treatment: {
    treatments: "Khử trùng",
    requests: "Yêu cầu khử trùng",
    database: "Dữ liệu khử trùng",
    failure_tracking: "Theo dõi sự cố",
    shipment_certificates: "Chứng thư đi tàu",
    shipment_certificates_report: "Báo cáo chứng thư",
    add: "Thêm dữ liệu khử trùng",
    edit: "Sửa dữ liệu khử trùng",
    detail: "Xem dữ liệu khử trùng",
    monitoring: "Theo dõi khử trùng",
    monitoring_detail: "Chi tiết theo dõi khử trùng",
	rpa: "Quản lý RPA",
  },
  treatmentRequest: {
    add: "Thêm yêu cầu khử trùng",
    edit: "Sửa yêu cầu khử trùng",
    detail: "Xem yêu cầu khử trùng",
  },
  failureTracking: {
    add: "Thêm sự cố",
    edit: "Chỉnh sửa sự cố",
    detail: "Chi tiết sự cố",
  },
  contents: "Nội dung",
  content: {
    contents: "Nội dung",
    mail_list: "Danh sách Thư",
    notification_list: "Danh sách Thông báo",
    instructions: "Hướng dẫn",
    maintenance_equipment: "Bảo trì",
    activity_logs: "Nhật ký hoạt động",
    license_list: "Danh sách giấy phép",
    web_config: "Cấu hình web",
  },
  maintenance: "Báo cáo Bảo trì",
  statistics: "Số liệu thống kê",
  support: {
    support: "Hỗ trợ",
    info: "Thông tin",
    license: "Giới thiệu",
  },
  configs: "Cấu hình",
  config: {
    mail: "Cấu hình Thư",
    password: "Yêu cầu mật khẩu",
    notification: "Cài đặt thông báo",
  },
  email: {
    list: "Danh sách email"
  },
  variable: {
    breadcumb: "Tham số"
  },
  shipment: {
    add: "Thêm yêu cầu",
    edit: "Sửa chứng thư đi tàu",
    detail: "Chi tiết chứng thư đi tàu",
  },
  license: {
    edit: "Chỉnh sửa giấy phép",
    review: "Xem trước"
  },
  rpa: {
    add: "Thêm RPA",
    edit: "Chỉnh sửa RPA",
    view: "Chi tiết RPA",
  }
};
